import React, { useId } from 'react';

const MatchbackEmptyStateIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const gradientId = useId();

  return (
    <svg width="178" height="142" viewBox="0 0 178 142" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="70.7711" cy="70.7711" r="70.7711" fill="#DAF2FF" />
      <circle
        cx="132.964"
        cy="70.7711"
        r="43.2133"
        stroke={`url(#${gradientId})`}
        strokeWidth="3.64578"
        strokeDasharray="4.29 4.29"
      />
      <circle
        cx="132.964"
        cy="70.7711"
        r="43.2133"
        stroke="white"
        strokeOpacity="0.1"
        strokeWidth="3.64578"
        strokeDasharray="4.29 4.29"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="87.9277"
          y1="34.1792"
          x2="185.142"
          y2="50.3479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1784EC" />
          <stop offset="0.5" stopColor="#FF8FA1" />
          <stop offset="1" stopColor="#FF6C0A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MatchbackEmptyStateIcon;
